import { configureStore as reduxToolKitStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import rootSagas from '../../sagas/rootSaga';
import rootReducer from '../reducers/rootReducer'
 
const configureStore = () => {
    const persistConfig = {
        key: 'uchainRoot',
        storage,
       // whitelist:['otpAuthentication']
    }
    const persistedReducer = persistReducer(persistConfig, rootReducer);
    // 1. Create a container object to hold dispatch
    const contextContainer = { dispatch: null };
    // 2. Pass the container into the saga middleware context using any name you like (e.g., 'appDispatch')
    const sagaMiddleware = createSagaMiddleware({
        context: {
            appDispatch: contextContainer
        }
    });
    const middleware = [sagaMiddleware];
    let store = reduxToolKitStore({
        reducer : persistedReducer,
        middleware: () => ([...middleware]),
        // devTools: process.env.NODE_ENV !== 'production',
    });
    // 3. Inject the live store dispatch method into your container object
    contextContainer.dispatch = store.dispatch;
    let persistor = persistStore(store);
    // Running sagas (Now your sagas will have access to the context container)
    sagaMiddleware.run(rootSagas);
    return { store, persistor };
}
export default configureStore;